import { hideNotification } from '@cian/favorites-assign-widget/es/shared/actions';

import { TThunkAction } from '../../types/redux';
import { deleteFromFavorite as deleteFromFavoriteService } from '../../services/favorites';
import { toggleFavorite } from '../../actions/recommendations';
import { trackDeleteFromFavorite } from './tracking';
import { TFavoriteActionParameters } from './types';

export function deleteFromFavorite(parameters: TFavoriteActionParameters): TThunkAction<Promise<void>> {
  return async (dispatch, _getState, context) => {
    const { recommendation } = parameters;

    dispatch(hideNotification());
    dispatch(toggleFavorite({ offerId: recommendation.offerId, isFavorite: false }));

    try {
      await deleteFromFavoriteService(context, {
        dealType: recommendation.dealType,
        offerId: recommendation.offerId,
        offerType: recommendation.offerType,
      });
    } catch (error) {
      dispatch(toggleFavorite({ offerId: recommendation.offerId, isFavorite: true }));

      throw error;
    }

    trackDeleteFromFavorite(parameters);
  };
}
